<template lang="html">
  <div ref="cursorElement" v-bind:class="{'html-cursor': true, hidden, inverted, circle}">
    test
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  mounted () {
    this.$cursorElement = $(this.$refs.cursorElement)
    $(document).on('mousemove', this.onMouseMove.bind(this))
    this.$bus.$on('set-cursor', this.setCursor.bind(this))
    this.$bus.$on('invert-cursor', this.invertCursor.bind(this))
    this.$bus.$on('hide-cursors', this.onHideCursors.bind(this))
    $('.hide-cursor').mouseenter(this.onHideCursors.bind(this, true))
    $('.hide-cursor').mouseleave(this.onHideCursors.bind(this, false))
  },
  data () {
    return {
      hidden: false,
      inverted: false,
      circle: false
    }
  },
  methods: {
    onMouseMove (e) {
      this.$cursorElement.css({
        top: e.clientY,
        left: e.clientX
      })
    },
    setCursor (type) {
      type = this.mapCursorDirection(type)
      switch (type) {
        case 'zoomIn':
          this.circle = true
          this.$cursorElement.empty()
          break
        case 'next':
        case 'back':
        case 'back to start':
          this.circle = false
          this.$cursorElement.html(`
            <div class="chapter-title">
              ${this.cursorDirectionToTranslatedDisplayText(type)}
            </div>
          `)
          break
        default:
          this.circle = false
          this.$cursorElement.html(`
            <div class="click-to-enter">${this.translate('cursor.click')}</div>
            <div class="click-to-enter">${this.translate('cursor.toEnter')}</div>
            <div class="chapter-title">
              ${this.cursorDirectionToTranslatedDisplayText(type)}
            </div>
          `)
      }
    },
    mapCursorDirection (direction) {
      switch (direction) {
        case 'double-dutch':
        case 'extremes':
        case 'the-end':
        case 'what':
        case 'when':
        case 'where':
        case 'who':
        case 'why':
        case 'back':
        case 'next':
        case 'back to start':
          return direction
        default:
          return 'zoomIn'
      }
    },
    cursorDirectionToTranslatedDisplayText (direction) {
      return this.translate('cursor.' + direction)
    },
    onHideCursors (hide) {
      this.hidden = hide
    },
    setCursorColor (color) {
      this.classes[color] = true
    },
    invertCursor (inverted) {
      this.inverted = inverted
    }
  }
}
</script>

<style lang="css">
.html-cursor {
  position: fixed;
  z-index: 2;
  pointer-events: none;
  color: white;
  line-height: 1.1;
  text-shadow: 0px 0px 35px rgba(0, 0, 0, 0.3);
}
.user-is-touching .html-cursor {
  display: none;
}
.circle {
  width: 30px;
  height: 30px;
  border: 2px solid white;
  border-radius: 50%;
}
.click-to-enter {
  font-size: 32px;
  font-weight: lighter;
}
.chapter-title {
  font-size: 32px;
  border-bottom: 4px solid black;
  text-transform: uppercase;
  font-weight: bold;
}
.inverted {
  color: black;
  border-color: black;
  text-shadow: 0px 0px 35px rgba(255, 255, 255, 0.3);
}
.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/HTMLCursor.vue